module.exports = __webpack_public_path__ + "static/media/undraw_misasesorias.64ac0160.svg";